export default class UploadEntity{
	constructor({file, show = false} = {}) {
	    this.file = file
		this.dataSrc = ''
		this.src = URL.createObjectURL(file)
		this.status = 'init'
		this.show = show
	}
}